import { Component, Inject, Input, Self, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { RegimeApiModel } from '@assetaccountant/core/models/regime-api-model';
import { NgControlDirective } from '@assetaccountant/core/utils/typed-forms';

@Component({
  selector: 'app-regimes-input',
  templateUrl: './regimes-input.component.html',
  styleUrls: ['./regimes-input.component.scss'],
  standalone: false,
})
export class RegimesInputComponent implements ControlValueAccessor {
  @Input() regimes: RegimeApiModel[];
  @Input() regimeTemplate?: TemplateRef<{ regime: RegimeApiModel }>;
  @Input() set disabledRegimes(value: number[] | undefined) {
    this.disabledState = {};
    if (value && value.length > 0) {
      value.forEach(regimeId => {
        this.disabledState[regimeId] = true;
        this.model[regimeId] = false;
      });
      this.ngControl.control?.setValue(this.getValue(), { emitModelToViewChange: false });
    }
  }

  model: Record<string | number, boolean | undefined> = {};
  disabledState: Record<string | number, boolean | undefined> = {};
  disabled = false;

  private _onChange: (value: number[]) => void = () => {};
  onTouched = () => {};

  constructor(@Self() @Inject(NgControl) private ngControl: NgControlDirective) {
    ngControl.valueAccessor = this;
  }

  writeValue(value: number[] | null | undefined): void {
    if (!value || value.length === 0) {
      this.model = {};
    } else {
      this.model = Object.fromEntries(
        value.map(regimeId => [regimeId, !this.disabledState[regimeId]]),
      );
      this.ngControl.control?.setValue(this.getValue(), { emitModelToViewChange: false });
    }
  }

  getValue() {
    return Object.entries(this.model)
      .filter(([_, checked]) => checked)
      .map(([regimeId, _]) => +regimeId);
  }

  onChange() {
    this._onChange(this.getValue());
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
